module.exports = __webpack_public_path__ + "static/media/logout.bcfce5c0.svg";